<script setup>

const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>

<template>
<v-text-field
	v-if="field.type !== 'string'"
	:label="field.label"
	:model-value="modelValue || ''"
	hide-details="auto"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
<v-text-field
	v-else
	:label="field.label"
	:model-value="modelValue"
	:type="field.type.split('-').pop()"
	hide-details
	readonly
	variant="outlined"
	class="mt-2"
/>
</template>

<style lang="scss" scoped>

</style>